const uploadEmptyFileErrorModalSupport = {
  label: 'Necesita seleccionar un archivo'
};

export default uploadEmptyFileErrorModalSupport;
